/* Casca do Painel do Cliente (a igreja/empresa).
 *
 * Mesmo design system Nebula, na variante clara (`.theme-light`) — mais
 * acolhedora para o público da igreja. Esta prévia foca nas duas telas pedidas,
 * Celulares e Campanhas; Visão geral e Conversas já existem no painel atual e
 * migram para cá quando a área do cliente virar oficial. */

import React, { useState } from 'react';

import '../admin/nebula.css';
import { Button, Icon } from '../admin/ui';
import Agentes from './Agentes';
import Campanhas from './Campanhas';
import Celulares from './Celulares';
import Conversas from './Conversas';
import VisaoGeral from './VisaoGeral';

const NAV = [
  { id: 'visao', rotulo: 'Visão geral', icone: 'layout-dashboard' },
  { id: 'conversas', rotulo: 'Conversas', icone: 'message-square' },
  { id: 'celulares', rotulo: 'Celulares', icone: 'smartphone' },
  { id: 'agentes', rotulo: 'Agentes', icone: 'cpu' },
  { id: 'campanhas', rotulo: 'Campanhas', icone: 'megaphone' },
];

function iniciais(nome) {
  if (!nome) return 'C';
  const p = nome.trim().split(/\s+/);
  return ((p[0]?.[0] || '') + (p.length > 1 ? p[p.length - 1][0] : '')).toUpperCase();
}

export default function PainelCliente({ usuario, empresa, aoSair }) {
  const [aba, definirAba] = useState('visao');
  const nomeEmpresa = empresa || 'Sua igreja';

  return (
    <div className="nebula theme-light" style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', background: 'var(--canvas)' }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 24, height: 60, flex: '0 0 auto', padding: '0 24px', background: 'var(--surface-sidebar)', borderBottom: '1px solid var(--border-subtle)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: 'var(--radius-md)', background: 'var(--accent)', color: '#fff', font: 'var(--type-title)', fontWeight: 'var(--fw-extrabold)' }}>S</span>
          <span style={{ font: 'var(--type-h3)', letterSpacing: 'var(--ls-tight)' }}>Sofia</span>
        </div>

        <nav style={{ display: 'flex', gap: 4, marginLeft: 8 }}>
          {NAV.map((n) => {
            const ativa = aba === n.id;
            return (
              <button
                key={n.id}
                type="button"
                onClick={() => definirAba(n.id)}
                aria-current={ativa ? 'page' : undefined}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 7, padding: '8px 12px', border: 0, cursor: 'pointer',
                  borderRadius: 'var(--radius-control)',
                  background: ativa ? 'var(--accent)' : 'transparent',
                  color: ativa ? 'var(--accent-on)' : 'var(--text-secondary)',
                  font: 'var(--type-body-strong)', fontSize: 'var(--fs-body-sm)', fontWeight: 'var(--fw-semibold)',
                }}
              >
                <Icon name={n.icone} size={15} />
                {n.rotulo}
              </button>
            );
          })}
        </nav>

        <div style={{ flex: 1 }} />

        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 34, padding: '0 12px', borderRadius: 'var(--radius-pill)', background: 'var(--surface-sunken)', border: '1px solid var(--border-subtle)', color: 'var(--text-secondary)', font: 'var(--type-label)' }}>
          <Icon name="building-2" size={14} />
          {nomeEmpresa}
        </span>

        {aoSair && (
          <Button variant="ghost" icon="log-out" onClick={aoSair} style={{ height: 34, padding: '0 12px', fontSize: 'var(--fs-body-sm)' }}>Sair</Button>
        )}

        <span title={usuario?.nome} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: '50%', background: 'var(--violet-700)', color: '#fff', font: 'var(--type-label)', fontWeight: 'var(--fw-bold)' }}>
          {iniciais(usuario?.nome)}
        </span>
      </header>

      <main style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {aba === 'visao' && <VisaoGeral />}
        {aba === 'conversas' && <Conversas />}
        {aba === 'celulares' && <Celulares />}
        {aba === 'agentes' && <Agentes />}
        {aba === 'campanhas' && <Campanhas />}
      </main>
    </div>
  );
}
